export function isString(value: any) {
  return typeof value === 'string' && value.trim().length > 0;
}
